module.exports = __webpack_public_path__ + "media/packs/images/flags/RS-c4aed63f54e346ce0dbb2771154a43c4.svg";